import { useEffect } from 'react'
import { Youtube } from 'lucide-react'
import '../DocumentPage.css'

const GettingStartedVideo = () => {
  useEffect(() => {
    const headings = document.querySelectorAll('.doc-content h2, .doc-content h3')
    headings.forEach((heading) => {
      if (!heading.id) {
        heading.id = heading.textContent.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '')
      }
    })
  }, [])

  return (
    <div className="doc-page">
      <div className="doc-content">
        <h1>YouTube: Getting Started</h1>
        <p className="lead">
          Complete getting started tutorial covering installation, configuration, and your first project.
        </p>

        <h2>Watch the Tutorial</h2>
        <div style={{
          position: 'relative',
          paddingBottom: '56.25%',
          height: 0,
          overflow: 'hidden',
          maxWidth: '100%',
          backgroundColor: 'var(--color-bg-elevated)',
          borderRadius: '8px',
          marginBottom: '2rem'
        }}>
          {/* YouTube video will be embedded here */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem'
          }}>
            <Youtube size={64} style={{ color: 'var(--color-brand)', marginBottom: '1rem' }} />
            <p style={{ textAlign: 'center', color: 'var(--color-text-secondary)' }}>
              YouTube video embed will be added here
            </p>
            <p style={{ fontSize: '0.9rem', color: 'var(--color-text-secondary)' }}>
              (Video URL to be provided)
            </p>
          </div>
          {/* Replace the above div with this when you have the URL:
          <iframe
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }}
            src="https://www.youtube.com/embed/YOUR_VIDEO_ID"
            title="Getting Started with Variable Modding System"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
          */}
        </div>

        <h2>Video Contents</h2>
        <h3>Topics Covered</h3>
        <ul>
          <li>Installing the Variable Modding System from Fab</li>
          <li>Enabling the plugin in your project</li>
          <li>Creating your first CSV configuration</li>
          <li>Importing data tables</li>
          <li>Testing in the editor</li>
          <li>Basic troubleshooting</li>
        </ul>

        <h3>Timestamps</h3>
        <ul>
          <li><strong>0:00</strong> - Introduction</li>
          <li><strong>1:30</strong> - Installation process</li>
          <li><strong>4:15</strong> - Creating your first configuration</li>
          <li><strong>8:45</strong> - Importing CSV files</li>
          <li><strong>12:30</strong> - Testing and validation</li>
          <li><strong>16:00</strong> - Common issues and solutions</li>
        </ul>

        <h2>Resources</h2>
        <p>Download the example project files used in this tutorial:</p>
        <ul>
          <li>Example CSV files</li>
          <li>Sample data table structures</li>
          <li>Test project files</li>
        </ul>

        <h2>Related Documentation</h2>
        <ul>
          <li><a href="#/getting-started/installation">Installation Guide</a></li>
          <li><a href="#/getting-started/initial-configuration">Initial Configuration</a></li>
          <li><a href="#/getting-started/in-editor-testing">In-Editor Testing</a></li>
        </ul>

        <h2>Need Help?</h2>
        <p>
          If you have questions about anything covered in this video, join our{' '}
          <a href="https://discord.gg/WbbBfkNaxt" target="_blank" rel="noopener noreferrer">
            Discord community
          </a>.
        </p>
      </div>
    </div>
  )
}

export default GettingStartedVideo
